







import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe
  }
})
export default class MemberEditIframe extends Vue {
  private get remoteSrc() {
    const queryObject = { memberNo: this.$route.query.memberNo as string ,serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/member/basic/edit' + '?' + queryString;

    return src;
  }
}
